import React from 'react';
import { formattedAmountWithCurrency } from '../../../../services/currency';
import UiLinearProgress from '../../../ui/linear-progress/UiLinearProgress';
import { RafBannerProperties } from '../../../../microservices/refer-a-friend/types';

interface Props {
    rafBannerMessage: RafBannerProperties;
}
export default function ReferAFriendBannerMessageProgress({ rafBannerMessage }: Props) {
    function getWagerRequirementText() {
        if (rafBannerMessage?.wager_requirement) {
            const wagerRequirementText = formattedAmountWithCurrency(rafBannerMessage.wager_requirement);
            return wagerRequirementText;
        }
        return '';
    }
    return (
        <div className="raf-progress-bar-container">
            <UiLinearProgress
                className="wagering-progress"
                color="var(--button-active-text-color)"
                animated={false}
                label={formattedAmountWithCurrency(rafBannerMessage.wagered_amount)}
                value={Math.min(
                    Math.floor((rafBannerMessage.wagered_amount * 100) / rafBannerMessage.wager_requirement),
                    100,
                )}
            />
            <div className="wager-requirement">{getWagerRequirementText()}</div>
        </div>
    );
}
